import React, { useEffect, useRef } from 'react';
import { connect } from 'react-redux';

import { toggleSpinner } from 'apps/auth/actions/appAction';
import { changeFormFieldValue, setNewForm } from 'apps/auth/actions/formAction';
import { Button } from 'apps/auth/components/common/Button/Button';
import { DiskBadge } from 'apps/auth/components/common/DiskBadge/DiskBadge';
import { HeaderPanel } from 'apps/auth/components/common/Layout/HeaderPanel/HeaderPanel';
import { Row } from 'apps/auth/components/common/Layout/Row';
import { Panel } from 'apps/auth/components/common/Panel/Panel';
import { DiskBadgeWrapper } from 'apps/auth/components/common/Panel/styles';
import { Text } from 'apps/auth/components/common/Text/Text';
import Form from 'apps/auth/components/form-multi/Form';
import InputText from 'apps/auth/components/form-multi/InputText';
import { getField } from 'apps/auth/components/form-multi/utils';
import { amplitudeEventForCompletedTopUp } from 'apps/auth/components/utils/AmplitudeUtils';
import ModalComponent from 'apps/auth/components/utils/ModalComponent';
import { topUpMethods } from 'apps/auth/constants/amplitude/AmplitudeParamValues';
import { logInfo } from 'apps/auth/helpers/clientLogger';
import { timer } from 'apps/auth/helpers/utils';

const FORM_NAME = 'searchPlaidBank';

const TopUpByPlaidSelectBank = (props) => {
    const submitRef = useRef(null);
    const submitPayRef = useRef(null);

    useEffect(() => {
        if (!props.search) {
            const search = getField('search', '', null, false, false, props.searchPlaceholder, 'search');
            props.setNewForm(FORM_NAME, { [search.name]: search });
        }
    }, []);

    const onSubmitHandler = (fields, json) => {
        if (json.extra?.linkToken && Plaid) {
            logInfo('link-initialize.js LOADED: ', Plaid);
            amplitudeEventForCompletedTopUp(topUpMethods.BANK_TRANSFER);
            const handler = Plaid.create({
                token: json.extra.linkToken,
                onSuccess: function (public_token, metadata) {
                    logInfo('onSuccess');
                    logInfo('public_token:', public_token);
                    logInfo('metadata: ', metadata);
                },
                onExit: function (err, metadata) {
                    logInfo('onExit');
                    logInfo('err:', err);
                    logInfo('metadata:', metadata);
                },
                onEvent: function (eventName, metadata) {
                    logInfo('onEvent');
                    if (eventName === 'HANDOFF') {
                        props.toggleSpinner(true);
                        window.location.href = `/auth/ga/pocket/${props.id}`;
                    }
                    logInfo('eventName:', eventName);
                    logInfo('metadata:', metadata);
                },
            });
            handler.open();
        }
    };

    const getBankLogo = (logo) => {
        if (logo) {
            return <DiskBadge variant="hasBorderedImg" src={`data:image/png;base64, ${logo}`} alt="" />;
        } else {
            return <DiskBadge variant="tertiary" iconName="bank" />;
        }
    };

    const getBankItem = (bank) => {
        return (
            <Panel
                type="button"
                isHoverable
                negativeMargin
                key={bank.id}
                onClick={() => {
                    props.changeFormFieldValue(props.formName, bank.id, 'bankId').then(() => {
                        submitPayRef.current.click();
                    });
                }}
            >
                <DiskBadgeWrapper>{getBankLogo(bank.logo)}</DiskBadgeWrapper>
                {bank.name}
            </Panel>
        );
    };

    const changeHandler = () => {
        timer(null, () => {
            submitRef.current.click();
        });
    };

    return (
        <ModalComponent isIconClose>
            <HeaderPanel title={props.selectBankTitle} />
            {props.search && (
                <Row indent="adaptive-32-48">
                    <Form action={`/auth/ga/pocket/${props.id}/top-up/plaid/search`} formName={FORM_NAME}>
                        <InputText formName={FORM_NAME} field={props.search} onChangeHandler={changeHandler} isNewInput />
                        <Button type="submit" variant={'hidden'} ref={submitRef} />
                    </Form>
                </Row>
            )}
            {props.canUseBankTransferMethod && (
                <Panel type="link" href={`/auth/ga/pocket/${props.id}/top-up/bank-transfer`} isHoverable negativeMargin>
                    <DiskBadgeWrapper>
                        <DiskBadge variant="secondary" iconName="bank" />
                    </DiskBadgeWrapper>
                    <Text color="primary">{props.bankNotInList}</Text>
                </Panel>
            )}
            {props.banks && props.banks.map((bank) => getBankItem(bank))}
            <Form formName={props.formName} action={`/auth/ga/pocket/${props.id}/top-up/plaid/pay.create`} onSubmitHandler={onSubmitHandler}>
                <Button type="submit" variant={'hidden'} ref={submitPayRef} />
            </Form>
        </ModalComponent>
    );
};

const mapStateToProps = (state) => {
    return {
        search: state.form[FORM_NAME]?.fields?.search,
        id: state.extra.id,
        banks: state.extra.banks,
        canUseBankTransferMethod: state.extra.canUseBankTransferMethod,
        searchPlaceholder: state.messages.pageMessages.searchPlaceholder,
        selectBankTitle: state.messages.pageMessages.selectBankTitle,
        bankNotInList: state.messages.pageMessages.bankNotInList,
    };
};
export default connect(mapStateToProps, {
    setNewForm,
    changeFormFieldValue,
    toggleSpinner,
})(TopUpByPlaidSelectBank);
